
import {
  defineStore
} from 'pinia'

export const useMobileMenuStore = defineStore('MobileMenuStore', {
  state: () => {
    return {
      slideoutOpen: false
    }
  },

  actions: {
    openSlideout () {
      this.slideoutOpen = true
      document.body.classList.add('overflow-hidden')
    },
    closeSlideout () {
      this.slideoutOpen = false
      document.body.classList.remove('overflow-hidden')
    }
  },
})
